<ui-card-table
  [showDrawer]="showDrawer"
  [hasBackdrop]="true"
  (openedDrawerChange)="openedDrawerChange($event)"
>
  <h4 card-title>Precios</h4>
  <div class="d-flex justify-content-between align-items-center" card-actions>
    <t-llevo-select-filter
      #vehicleTypeFilter
      label="Tipo de vehículo"
      [data]="VehicleTypesNames() ?? []"
      [disabled]="(dataSource.loading$ | async) ?? false"
      (valueChange)="filter()"
      class="mx-1"
      cancelSelectionText="Desactivar filtros"
    ></t-llevo-select-filter>

    <t-llevo-select-filter
      #currencyFilter
      label="Moneda"
      [data]="currencyList"
      [disabled]="(dataSource.loading$ | async) ?? false"
      (valueChange)="filter()"
      class="mx-1"
      cancelSelectionText="Desactivar filtros"
    ></t-llevo-select-filter>

    <button
      class="button-outline-primary mb-1 controls-button"
      mat-flat-button
      color="accent"
      (click)="openAddItemDialog()"
      class="mx-2"
    >
      Adicionar
    </button>
  </div>

  <div
    card-drawer-content
    class="row align-items-start justify-content-start w-100 gx-0"
    commonui-loader
    [appLoader]="(dataSource.loading$ | async) ?? false"
  >
    <div class="col-12">
      <mat-table
        [dataSource]="dataSource"
        matSort
        matSortDisableClear
        matSortDirection="asc"
      >
        <ng-container matColumnDef="vehicleType">
          <mat-header-cell *matHeaderCellDef>
            Tipo de vehículo
          </mat-header-cell>
          <mat-cell *matCellDef="let item">
            {{ item.typeVehicle ? getVehicleById(item.typeVehicle) : '-' }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="currency">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            Moneda
          </mat-header-cell>
          <mat-cell *matCellDef="let item">
            <div>
              <span>
                {{ item.currency }}
              </span>
            </div>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="baseFee">
          <mat-header-cell *matHeaderCellDef>Tarifa Base</mat-header-cell>
          <mat-cell *matCellDef="let item">
            {{ item.baseFee }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="status">
          <mat-header-cell *matHeaderCellDef>Estado</mat-header-cell>
          <mat-cell *matCellDef="let item">
            <edt-tag
              border_radius="8px"
              [color]="item.isActive ? '#166534' : '#9f1239'"
            >
              {{ item.isActive ? 'Habilitado' : 'Deshabilitado' }}
            </edt-tag>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="actions">
          <mat-header-cell
            class="action-col-centered justify-content-center"
            *matHeaderCellDef
          >
            <span class="d-none d-md-block">Acciones</span>
          </mat-header-cell>
          <mat-cell
            class="action-col-centered justify-content-center"
            *matCellDef="let item"
          >
            <div class="d-none d-lg-flex">
              <ng-container>
                <button
                  mat-icon-button
                  matTooltip="Detalles"
                  (click)="detail(item)"
                >
                  <mat-icon svgIcon="eye" class="me-1"></mat-icon>
                </button>
              </ng-container>
              <ng-container>
                <button
                  mat-icon-button
                  [matTooltip]="item.isActive ? 'Deshabilitar' : 'Habilitar'"
                  (click)="openChangeStatusDialog(item)"
                >
                  <mat-icon
                    [svgIcon]="
                      item.isActive
                        ? 'archive-cancel-outline'
                        : 'archive-check-outline'
                    "
                    class="me-1"
                  ></mat-icon>
                </button>
              </ng-container>
              <ng-container>
                <button
                  mat-icon-button
                  matTooltip="Editar"
                  (click)="openEditDialog(item)"
                >
                  <mat-icon svgIcon="pencil" class="me-1"></mat-icon>
                </button>
              </ng-container>
              <ng-container>
                <button
                  mat-icon-button
                  matTooltip="Eliminar"
                  (click)="openDeleteDialog(item)"
                >
                  <mat-icon
                    svgIcon="trash-can"
                    class="action_element"
                  ></mat-icon>
                </button>
              </ng-container>
            </div>

            <!-- MOBILE ACTIONS MENU-->
            <div class="d-block d-lg-none">
              <button
                mat-icon-button
                [matMenuTriggerFor]="menu"
                aria-label="Acciones"
              >
                <mat-icon
                  svgIcon="expand_vert"
                  class="action_element"
                ></mat-icon>
              </button>
              <mat-menu #menu="matMenu">
                <ng-container>
                  <button mat-menu-item (click)="detail(item)">
                    <mat-icon svgIcon="eye"></mat-icon>
                    <span>Detalles</span>
                  </button>
                </ng-container>
              </mat-menu>
            </div>
          </mat-cell>
        </ng-container>

        <mat-header-row
          *matHeaderRowDef="displayedColumns; sticky: true"
        ></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
        <div class="w-100 text-center pt-3 text-muted" *matNoDataRow>
          Sin resultados para mostrar
        </div>
      </mat-table>
    </div>
  </div>
  <mat-paginator
    card-drawer-paginator
    [length]="(dataSource.total$ | async) ?? 0"
    [pageSize]="dataSource.PAGE_SIZE"
    [pageSizeOptions]="dataSource.PAGE_SIZE_OPTIONS"
    #paginator
  >
  </mat-paginator>
  <mat-tab-group animationDuration="200" card-drawer>
    <mat-tab label="Detalles" bodyClass="tab-body">
      <t-llevo-travel-pricing-details class="px-3 d-block"></t-llevo-travel-pricing-details>
    </mat-tab>
  </mat-tab-group>
</ui-card-table>
